import { render, staticRenderFns } from "./acceptDialog.vue?vue&type=template&id=50ff6f9f&scoped=true&"
import script from "./acceptDialog.vue?vue&type=script&lang=js&"
export * from "./acceptDialog.vue?vue&type=script&lang=js&"
import style0 from "./acceptDialog.vue?vue&type=style&index=0&id=50ff6f9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ff6f9f",
  null
  
)

export default component.exports